import { Component, Input, OnInit } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { ComponentBase } from 'src/app/views/component-base';
import { InvestmentItemModel } from 'src/app/model/investment-item.model';
import { NgIf } from '@angular/common';


@Component({
    selector: 'app-investment-review-card',
    templateUrl: './investment-review-card.component.html',
    styleUrls: ['./investment-review-card.component.scss'],
    imports: [
        NgIf
    ],
})
export class InvestmentReviewCardComponent extends ComponentBase implements OnInit, OnDestroy {
    @Input() set investment(value: InvestmentItemModel) {
        this._investment = value;
    }

    _investment:InvestmentItemModel = null;

    constructor() {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }
}
